import Component from './FlashMessage'

export default Component
